import ConfigStyle from 'core/constants/ConfigStyle';

const getNotificationColors = (type: string) => {
  let borderColor;
  let backgroundColor;
  switch (type) {
    case 'success':
      borderColor = ConfigStyle.colors['success-500'];
      backgroundColor = ConfigStyle.colors['success-50'];
      break;
    case 'warning':
      borderColor = ConfigStyle.colors['secondary-600']; // '#faad14';
      backgroundColor = ConfigStyle.colors['success-50']; // '#fff7cc';
      break;
    case 'error':
      borderColor = ConfigStyle.colors['danger-500'];
      backgroundColor = ConfigStyle.colors['danger-50'];
      break;
    default:
      borderColor = ConfigStyle.colors['info-500'];
      backgroundColor = ConfigStyle.colors['info-50'];
  }
  return { borderColor, backgroundColor };
};

export default getNotificationColors;
